import { useAppSelector } from "app/hooks";
import { staffTaskSettingsSelector } from "features/auth/auth-slice";

// Practice-level "required task fields" setting (Practice.staff_task_settings).
// Falsy-safe: an old backend (key absent) or an unconfigured practice (null)
// both resolve to "nothing required", matching pre-feature behavior.
export const useStaffTaskRequiredFields = () => {
  const staffTaskSettings = useAppSelector(staffTaskSettingsSelector);

  return {
    isDueDateRequired: Boolean(staffTaskSettings?.required_fields?.due_at),
    isPriorityRequired: Boolean(staffTaskSettings?.required_fields?.priority)
  };
};

export default useStaffTaskRequiredFields;
